import _ from 'lodash'
import moment from 'moment'
import visitorApi from '@/services/api/visitor'

const state = {
  buildingId: '',
  startedAt: 0,
  duration: 0
}

export const getters = {
}

// Enable by usernames
const usersToEnable = [
  'istaging_miiya_tw'
]
// Map usernames to headquarters for api
const userHqMaps = {
  istaging_miiya_tw: 'miiya',
  'action+all@staging.com.tw': 'miiya'
}
// Enable by headquarters
const hqsToEnable = []
let headquarter = ''

const interval = 10 // seconds
let timer = null
export const actions = {
  async startViewSession ({
    dispatch,
    commit,
    rootGetters
  }, buildingId) {
    buildingId = buildingId || rootGetters.currentBuilding.objectId

    if (process.env.NODE_ENV === 'dev') {
      // usersToEnable.push('action+all@staging.com.tw')
    }

    const username = rootGetters.user.username
    const userHq = rootGetters.headquarter.title
    if (
      !buildingId ||
      !rootGetters['auth/isLogin'] ||
      (!usersToEnable.includes(username) && !hqsToEnable.includes(userHq))
    ) {
      return
    }
    if (usersToEnable.includes(username) && username in userHqMaps) {
      headquarter = userHqMaps[username]
    } else {
      headquarter = userHq
    }

    clearInterval(timer)
    let counter = 0
    timer = setInterval(() => {
      counter++
      commit('updateDuration', counter)
      if (counter % interval === 0) {
        dispatch('updateViewSession')
      }
    }, 1000)

    const payload = {
      buildingId,
      startedAt: Number(moment().format('x')),
      duration: 0
    }
    await visitorApi.addDetailVisitorHistory({ headquarter, payload })
    commit('updateState', payload)
    console.log('[VisitorHistory] view session started.', payload)
  },
  async updateViewSession ({ commit, state, rootGetters }, reset = false) {
    if (!state.buildingId || !rootGetters['auth/isLogin']) {
      return
    }
    if (reset) {
      clearInterval(timer)
    }
    const payload = _.clone(state)
    await visitorApi.addDetailVisitorHistory({ headquarter, payload })
    if (reset) {
      payload.buildingId = ''
      payload.startedAt = 0
      payload.duration = 0
    }
    commit('updateState', payload)
    console.log('[VisitorHistory] view session updated.', payload)
  },
  async resetViewSession ({ dispatch }) {
    clearInterval(timer)
    await dispatch('updateViewSession', true)
    console.log('[VisitorHistory] view session reset.')
  }
}

export const mutations = {
  updateState (state, payload) {
    Object.keys(payload).forEach(key => {
      state[key] = payload[key]
    })
  },
  updateDuration (state, seconds) {
    state.duration = seconds
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
